/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * copyableInlineLinkTextUtils
 *
 * @file copyableInlineLinkTextUtils.js
 * @author Anuja Gaikwad
 * @since 2.3.7
 */

export const getLinkCopyText = (text, href) => `${text} [${href}]`;

export const getCopyTextFromSegments = (segments = []) => (
  segments.map((segment) => {
    if (segment.isLink) {
      return segment.copyText || getLinkCopyText(segment.text, segment.href);
    }

    return segment.text || '';
  }).join('')
);

export const getCopyTextFromSubInstructions = (subInstructions = []) => (
  subInstructions.map((item) => {
    if (item.segments?.length) {
      return getCopyTextFromSegments(item.segments);
    }

    return item.details || '';
  }).join('')
);
